<template>
  <div class="container register">
    <modal v-if="message.show" @close="logout" :title="message.title" :body="message.body" :type="message.type">
    </modal>
    <div class="block-screen" v-if="loading">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <navbar></navbar>
    <modal v-if="hasErrors" @close="closeModal" title="Erro ao cadastrar."
      body="Ocorreu uma falha ao efetuar o cadastro. Verifique os campos e tente novamente.">
    </modal>
    <modal v-if="displayConfirmInfo" @close="closeModal" title="Atenção"
      body="É necessário confirmar que as informações fornecidas são verdadeiras para efetuar o cadastro.">
    </modal>
    <modal v-if="displayPassportValidityInfo" @close="closeModal" title="Atenção"
      body="Seu passaporte está próximo ao prazo de validade, por favor verificar se será necessário a emissão de um novo passaporte para esta viagem.">
    </modal>
    <modal v-if="displayFlightModal" @close="closeModal" title="Info" type="info"
      body="Olá! Volte para se cadastrar e escolher seus voos no dia de abertura de sua classificação."
      :redirect="false">
    </modal>
    <modal v-if="displayPartnerInfo" @close="closeModal" title="Info" type="info"
      body="Os responsáveis técnicos das corretoras franqueadas qualificadas poderão indicar como acompanhantes durante o evento o Sócio(a) / Preposto de sua corretora franqueada e seus familiares, assim como noivo(a), namorado(a), cunhado(a), sogro(a), padrasto (madrasta), enteado(a). Seja na condição de acompanhante qualificado quanto na condição de acompanhante extra."
      :redirect="false">
    </modal>
    <modal v-if="displayCityInfo" @close="closeModal" title="Info" type="info"
      body="A franqueadora não custeará o trecho nacional para as corretoras franqueadas que optarem por voar em uma cidade diferente do Ponto de Apoio Principal.">
    </modal>
    <modal v-if="displayPassportName" @close="closeModal" title="Info" type="info"
      body="Nome deve ser exatamente igual ao que está no passaporte. A Origami e a Prudential não poderão ser responsabilizadas em caso de nome errado.">
    </modal>
    <modal v-if="displayPassportNumber" @close="closeModal" title="Info" type="info"
      body="O número deve ser exatamente igual ao que está no passaporte. A Origami e a Prudential não poderão ser responsabilizadas em caso de nome errado">
    </modal>
    <modal v-if="displayPassportCountry" @close="closeModal" title="Info" type="info"
      body="País de emissão do passaporte.">
    </modal>
    <modal v-if="displaySpouseMessage" @close="closeModal" title="Info"
      body="Já existe outro acompanhante como cônjuge">
    </modal>
    <main class="row" id="content" v-if="canRegister">
      <header>
        <h1>Cadastro responsável técnico e acompanhantes</h1>
        <p>Cadastre-se como participante e adicione seus acompanhantes.</p>
        <hr />
      </header>
      <div class="col-sm-12">
        <tabs>
          <tab id="tab1" name="Cadastro" :tabName="tabName" :isValid="true" icon="icon icon-tab1" selected="true">
            <infos :type="1" v-if="showFirstInfo" @nextButton="
              showFirstInfo = false;
            showSecondInfo = true;
            scrollOnTop();
            ">
            </infos>
            <infos :type="2" v-if="showSecondInfo" @nextButton="
              showFirstInfo = false;
            showSecondInfo = false;
            scrollOnTop();
            " @goBack="
              showFirstInfo = true;
            showSecondInfo = false;
            scrollOnTop();
            ">
            </infos>
            <form role="form" v-show="!showFirstInfo && !showSecondInfo">
              <div class="row">
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{
                    'has-error': $v.participant.passportFirstName.$error,
                  }">
                    <label for="">Nome conforme passaporte
                      <span v-if="!participant.hasPassport">*</span></label>
                    <input type="text" @input="$v.participant.passportFirstName.$touch()"
                      placeholder="Nome conforme passaporte" v-model="participant.passportFirstName" autofocus />
                    <span class="text-danger" v-if="$v.participant.passportFirstName.$error">Obrigatório.</span>
                    <span class="text-danger" v-if="
                      $v.participant.passportFirstName.required &&
                      $v.participant.passportFirstName.$invalid
                    ">
                      <span style="font-size: 75%">Máx 23 caracteres</span>
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{
                    'has-error': $v.participant.passportLastName.$error,
                  }">
                    <label for="">Sobrenome conforme passaporte
                      <span v-if="!participant.hasPassport">*</span></label>
                    <input type="text" @input="$v.participant.passportLastName.$touch()"
                      placeholder="Sobrenome conforme passaporte" v-model="participant.passportLastName" autofocus />
                    <span class="text-danger" v-if="$v.participant.passportLastName.$error">Obrigatório.</span>
                    <span class="text-danger" v-if="
                      $v.participant.passportLastName.required &&
                      $v.participant.passportLastName.$invalid
                    ">
                      <span style="font-size: 75%">Máx 23 caracteres</span>
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{
                    'has-error': $v.participant.passportNumber.$error,
                  }">
                    <label for="">Número do passaporte
                      <span v-if="!participant.hasPassport">*</span></label>
                    <input type="text" @input="$v.participant.passportNumber.$touch()"
                      placeholder="Número do passaporte" v-model="participant.passportNumber" autofocus />
                    <span class="text-danger" v-if="$v.participant.passportNumber.$error">Obrigatório.</span>
                    <span class="text-danger" v-if="
                      $v.participant.passportNumber.required &&
                      $v.participant.passportNumber.$invalid
                    ">
                      <span style="font-size: 75%">Máx 23 caracteres</span>
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{ 'has-error': $v.participant.nacionality.$error }">
                    <label for="">Nacionalidade
                      <span v-if="!participant.hasPassport">*</span></label>
                    <input type="text" @input="$v.participant.nacionality.$touch()" placeholder="Nacionalidade"
                      v-model="participant.nacionality" autofocus />
                    <span class="text-danger" v-if="$v.participant.nacionality.$error">Obrigatório.</span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{
                    'has-error': $v.participant.passportAuthority.$error,
                  }">
                    <label for="">País emissor
                      <span v-if="!participant.hasPassport">*</span></label>
                    <input type="text" @input="$v.participant.passportAuthority.$touch()" placeholder="País emissor"
                      v-model="participant.passportAuthority" autofocus />
                    <span class="text-danger" v-if="$v.participant.passportAuthority.$error">Obrigatório.</span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{
                    'has-error': $v.participant.passportValidity.$error,
                  }">
                    <label for="">Data de validade do passaporte
                      <span v-if="!participant.hasPassport">*</span></label>
                    <input type="text" @input="$v.participant.passportValidity.$touch()"
                      placeholder="Validade do passaporte" v-model="participant.passportValidity" v-mask="'##/##/####'"
                      autofocus />
                    <span class="text-danger" v-if="
                      !$v.participant.passportValidity.required &&
                      $v.participant.passportValidity.$error
                    " style="font-size: 10px">
                      Obrigatório.
                    </span>
                    <span class="text-danger" v-if="
                      $v.participant.passportValidity.required &&
                      $v.participant.passportValidity.$invalid
                    ">Inválida.
                    </span>
                  </div>
                </div>
                <!-- <div class="col-lg-3 col-sm-6">
                  <div
                    class="form-group"
                    :class="{ 'has-error': $v.participant.badgeName.$error }"
                  >
                    <label for="">Nome completo *</label>
                    <input
                      type="text"
                      @input="$v.participant.badgeName.$touch()"
                      placeholder="Nome completo *"
                      v-model="participant.badgeName"
                      autofocus
                    />
                    <span
                      class="text-danger"
                      v-if="!$v.participant.badgeName.required"
                      >Obrigatório.</span
                    >
                    <span
                      class="text-danger"
                      v-if="
                        $v.participant.badgeName.required &&
                        $v.participant.badgeName.$invalid
                      "
                    >
                      <span style="font-size: 75%">Máx 23 caracteres</span>
                    </span>
                  </div>
                </div> -->
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{ 'has-error': $v.participant.dateOfBirth.$error }">
                    <label for="">Data de Nascimento *</label>
                    <input type="text" @input="$v.participant.dateOfBirth.$touch()" placeholder="Data de Nascimento *"
                      v-model="participant.dateOfBirth" v-mask="'##/##/####'" autofocus />
                    <span class="text-danger" v-if="
                      !$v.participant.dateOfBirth.required &&
                      $v.participant.dateOfBirth.$error
                    ">
                      Obrigatório.
                    </span>
                    <span class="text-danger" v-if="
                      $v.participant.dateOfBirth.required &&
                      $v.participant.dateOfBirth.$invalid
                    ">Inválida.
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{ 'has-error': $v.participant.cpf.$error }">
                    <label for="">CPF *</label>
                    <input type="text" @input="$v.participant.cpf.$touch()" placeholder="CPF *"
                      v-model="participant.cpf" v-mask="'###.###.###-##'" autofocus />
                    <span class="text-danger" v-if="$v.participant.cpf.$error">Obrigatório.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{ 'has-error': $v.participant.rg.$error }">
                    <label for="">RG <span v-if="!participant.hasRg">*</span></label>
                    <input type="text" @input="$v.participant.rg.$touch()" placeholder="RG" maxlength="18"
                      v-model="participant.rg" autofocus />
                    <span class="text-danger" v-if="$v.participant.rg.$error">Obrigatório.</span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{ 'has-error': $v.participant.validadeRg.$error }">
                    <label for="">Validade do RG <span v-if="!participant.hasRg">*</span></label>
                    <input type="text" @input="$v.participant.validadeRg.$touch()" v-mask="'##/##/####'" placeholder="validade do RG"
                      v-model="participant.validadeRg" autofocus />
                  </div>
                </div>
                 <div class="col-lg-3 col-sm-6">
                  <div class="checkbox">
                    <input type="checkbox" id="hasRg" v-model="participant.hasRg"
                      @change="$v.participant.$reset()" />
                    <label for="hasRg"><small>Não possuo</small></label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{ 'has-error': $v.participant.email.$error }">
                    <label for="">E-mail *</label>
                    <input type="email" @input="$v.participant.email.$touch()" placeholder="E-mail *"
                      v-model="participant.email" autofocus />
                    <span class="text-danger" v-if="$v.participant.email.$error">Obrigatório.</span>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 hide">
                  <div class="form-group" :class="{ 'has-error': $v.participant.registration.$error }">
                    <label for="">CPD *</label>
                    <input type="text" disabled @input="$v.participant.registration.$touch()" placeholder="CPD *"
                      v-model="participant.registration" autofocus />
                    <span class="text-danger" v-if="$v.participant.registration.$error">Obrigatório.</span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group" :class="{ 'has-error': $v.participant.cellPhone.$error }">
                    <label for="">Telefone celular *</label>
                    <input type="text" @input="$v.participant.cellPhone.$touch()" placeholder="Telefone celular *"
                      v-model="participant.cellPhone" v-mask="'(##) #####-####'" autofocus />
                    <span class="text-danger" v-if="$v.participant.cellPhone.$error">Obrigatório.</span>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                  <div class="form-group radio-content" :class="{ 'has-error': $v.participant.gender.$error }">
                    <label for="" class="control-label visible-label">Sexo *</label>
                    <br />
                    <input type="radio" name="gender" id="male" value="1" v-model="participant.gender" />
                    <label for="male">Masculino</label>
                    <input type="radio" name="gender" id="female" value="2" v-model="participant.gender" />
                    <label for="female">Feminino</label>
                    <span class="text-danger" v-if="$v.participant.gender.$error">Obrigatório.</span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group select select-fancy select-fancy-noimage"
                    :class="{ 'has-error': $v.participant.foodId.$error }">
                    <label for="">Restrição/Necessidade alimentar *</label>
                    <select v-model="participant.foodId">
                      <option value="null" disabled selected>
                        Selecione o tipo:
                      </option>
                      <option v-for="food in foodList" :key="food.id" :value="food.id">
                        {{ food.name }}
                      </option>
                    </select>
                    <span class="text-danger" v-if="$v.participant.foodId.$error" style="font-size: 9px">
                      Obrigatório.
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6" v-if="participant.foodId == 9">
                  <div class="form-group">
                    <label for="">Descreva sua restrição alimentar</label>
                    <input type="text" name="otherFood" v-model="participant.otherFood"
                      @input="$v.participant.otherFood.$touch()" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group select select-fancy select-fancy-noimage"
                    :class="{ 'has-error': $v.participant.pwdId.$error }">
                    <label for="">Necessidades especiais *</label>
                    <select v-model="participant.pwdId">
                      <option value="null" disabled selected>
                        Selecione o tipo:
                      </option>
                      <option v-for="pwd in pwdList" :key="pwd.id" :value="pwd.id">
                        {{ pwd.name }}
                      </option>
                    </select>
                    <span class="text-danger" v-if="$v.participant.pwdId.$error" style="font-size: 9px">
                      Obrigatório.
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6" v-if="participant.pwdId == 5">
                  <div class="form-group">
                    <label for="">Descreva sua necessidade especial</label>
                    <input type="text" name="otherPwd" v-model="participant.otherPwd"
                      @input="$v.participant.otherPwd.$touch()" />
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-lg-3 col-sm-6">
                    <div class="checkbox" >
                      <input type="checkbox" id="hasVisa" v-model="participant.hasVisa" 
                        @change="$v.participant.$reset()">
                      <label for="hasVisa"><small>Não possui visto americano?</small></label>
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-6">
                    <div class="form-group" v-if="!participant.hasVisa"
                      :class="{ 'has-error': $v.participant.visaValidity.$error }">
                      <label for="">Data de validade do visto americano *</label>
                      <input type="text" @input="$v.participant.visaValidity.$touch()" placeholder="Validade do visto *" v-model="participant.visaValidity" v-mask="'##/##/####'" autofocus>
                      <span class="text-danger" v-if="!$v.participant.visaValidity.required &&
                        $v.participant.visaValidity.$error" style="font-size: 7px;">
                        Obrigatório.
                      </span>
                      <span class="text-danger" v-if="$v.participant.visaValidity.required &&
                        $v.participant.visaValidity.$invalid" style="font-size: 9px;">Inválida.
                      </span>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="col-lg-3 col-sm-6">
                  <div class="form-group select select-fancy select-fancy-noimage"
                    :class="{ 'has-error': $v.participant.supportPoint.$error }">
                    <label for="">
                      Ponto de Apoio *
                    </label>
                    <select v-model="participant.supportPoint">
                      <option value="null" disabled selected>
                        Selecione o ponto de apoio:
                      </option>
                      <option key="1" value="1">1</option>
                      <option key="All Blacks" value="All Blacks">
                        All Blacks
                      </option>
                      <option key="Arrows" value="Arrows">Arrows</option>
                      <option key="Azzurra" value="Azzurra">Azzurra</option>
                      <option key="Batel" value="Batel">Batel</option>
                      <option key="Black Belt" value="Black Belt">
                        Black Belt
                      </option>
                      <option key="Brooklin" value="Brooklin">Brooklin</option>
                      <option key="CHAMPS" value="CHAMPS">CHAMPS</option>
                      <option key="Dojô" value="Dojô">Dojô</option>
                      <option key="Everest" value="Everest">Everest</option>
                      <option key="Excalibur" value="Excalibur">
                        Excalibur
                      </option>
                      <option key="Federal" value="Federal">Federal</option>
                      <option key="Fenix" value="Fenix">Fenix</option>
                      <option key="Futuro" value="Futuro">Futuro</option>
                      <option key="Heroes" value="Heroes">Heroes</option>
                      <option key="Hunters" value="Hunters">Hunters</option>
                      <option key="Imperio" value="Imperio">Imperio</option>
                      <option key="Invictus" value="Invictus">Invictus</option>
                      <option key="Island" value="Island">Island</option>
                      <option key="Locomotiva" value="Locomotiva">
                        Locomotiva
                      </option>
                      <option key="Marines" value="Marines">Marines</option>
                      <option key="Platinum" value="Platinum">Platinum</option>
                      <option key="Pride" value="Pride">Pride</option>
                      <option key="Prime" value="Prime">Prime</option>
                      <option key="Seals" value="Seals">Seals</option>
                      <option key="Shields" value="Shields">Shields</option>
                      <option key="Shogun" value="Shogun">Shogun</option>
                      <option key="Star" value="Star">Star</option>
                      <option key="Stones" value="Stones">Stones</option>
                      <option key="SUITS" value="SUITS">SUITS</option>
                      <option key="Titanium" value="Titanium">Titanium</option>
                      <option key="Union" value="Union">Union</option>
                      <option key="Vikings" value="Vikings">Vikings</option>
                      <option key="VIP" value="VIP">VIP</option>
                    </select>
                    <span class="text-danger" v-if="$v.participant.supportPoint.$error">Obrigatório.</span>
                  </div>
                </div> -->
              </div>
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group" :class="{ 'has-error': $v.participant.startCity.$error }">
                    <label for="">
                      Cidade de partida / Aeroporto de partida *
                      <i class="fa fa-question-circle" @click="displayCityInfo = true"></i>
                    </label>
                    <input type="text" @input="$v.participant.startCity.$touch()"
                      placeholder="Cidade de partida / Aeroporto de partida *" v-model="participant.startCity"
                      autofocus />
                    <span class="text-danger" v-if="$v.participant.startCity.$error">Obrigatório.</span>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group" :class="{ 'has-error': $v.participant.returnCity.$error }">
                    <label for="">
                      Cidade de retorno / Aeroporto de retorno *
                      <i class="fa fa-question-circle" @click="displayCityInfo = true"></i>
                    </label>
                    <input type="text" @input="$v.participant.returnCity.$touch()"
                      placeholder="Cidade de retorno / Aeroporto de retorno *" v-model="participant.returnCity"
                      autofocus />
                    <span class="text-danger" v-if="$v.participant.returnCity.$error">Obrigatório.</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-sm-6">
                  <div class="checkbox">
                    <input type="checkbox" id="hasPassport" v-model="participant.hasPassport"
                      @change="$v.participant.$reset()" />
                    <label for="hasPassport"><small>Não possui passaporte?</small></label>
                  </div>
                </div>
                <div class="col-sm-12" v-if="participant.hasPassport">
                  <p style="margin: -20px 0 50px">
                    <i class="modal-icon fa fa-exclamation-circle"></i>&nbsp;<b>Será necessário enviar a foto dos dados pessoais do passaporte, posteriormente para o e-mail 
                      <a href="ptcpiic.brasil@prudential.com ">ptcpiic.brasil@prudential.com</a>, 
                      até o dia 31/03/2025. Essa é uma exigência da cia aérea para emissão da passagem aérea, 
                      para que não haja nenhum problema no embarque, ocasionando possíveis futuros custos.</b>
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <p>
                    <b>Importante:</b> Caso a cidade de origem e retorno seja diferente da cidade do Ponto de Apoio ao
                    desenvolvimento dos negócios da MFA, com a qual as MFBs possuírem contrato de subfranquias, bem como
                    as respectivas CFs subfranqueadas, poderá ocorrer a cobrança de custos adicionais em relação a
                    tarifa base definida para a Convenção.
                  </p>
                  <p>
                    Os responsáveis técnicos e acompanhantes, qualificados e
                    extras, devem providenciar a documentação necessária para
                    entrada no país sede da Convenção. Assim como consultar
                    regras e documentações necessárias para as cidades que irão
                    visitar ou fazer conexões, conforme informado no comunicado
                    enviado pela Franqueadora.
                  </p>
                  <p>
                    <b>Atenção:</b> O prazo para cancelamento de participação na PTC 2025, sem custos, é 31/03/2025.
                  </p>
                </div>
              </div>

              <custom-button @clicked="
                showFirstInfo = false;
              showSecondInfo = true;
              scrollOnTop();
              " myText="Voltar" icon="chevron-left" pos="left"></custom-button>
              <custom-button :disabled="$v.participant.$error" @clicked="
                changeTab(
                  'Acompanhantes',
                  $v.participant.$invalid,
                  $v.participant.$touch(),
                  'showThirdInfo',
                  true
                );
              scrollOnTop();
              " myText="Próximo" icon="chevron-right" pos="right"></custom-button>
            </form>
          </tab>
          <tab id="tab2" name="Acompanhantes" :tabName="tabName" :isValid="true" icon="icon icon-tab2">
            <infos :type="3" v-if="showThirdInfo" @nextButton="
              showThirdInfo = false;
            scrollOnTop();
            " @goBack="
              changeTab('Cadastro');
            scrollOnTop();
            ">
            </infos>
            <div data-name="guest-form" v-for="(guest, i) in guests" :key="i">
              <form role="form" v-if="!showThirdInfo">
                <div class="panel-group" :id="'panels' + (i + 1)">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h4 class="panel-title">
                        <a data-toggle="collapse"> Acompanhante {{ i + 1 }} </a>
                        <a href="#" type="button" class="collapse-arrow"></a>
                        <button type="button" @click.prevent="removeGuest(i, guest.id)" class="close"
                          aria-hidden="true">
                          &times;
                        </button>
                      </h4>
                    </div>
                    <div :id="'collapse' + (i + 1)" class="panel-collapse collapse in">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].passportFirstName.$error,
                            }">
                              <label for="">Nome conforme passaporte
                                <span v-if="!guest.hasPassport">*</span></label>
                              <input type="text" @input="
                                $v.guests.$each[i].passportFirstName.$touch()
                                " placeholder="Nome conforme passaporte" v-model="guest.passportFirstName" autofocus />
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].passportFirstName
                                  .required &&
                                $v.guests.$each[i].passportFirstName.$error
                              ">
                                Obrigatório.
                              </span>
                              <span class="text-danger" v-if="
                                $v.guests.$each[i].passportFirstName
                                  .required &&
                                $v.guests.$each[i].passportFirstName.$invalid
                              ">
                                Máx 23 caracteres
                              </span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].passportLastName.$error,
                            }">
                              <label for="">Sobrenome conforme passaporte
                                <span v-if="!guest.hasPassport">*</span></label>
                              <input type="text" @input="
                                $v.guests.$each[i].passportLastName.$touch()
                                " placeholder="Sobrenome conforme passaporte" v-model="guest.passportLastName"
                                autofocus />
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].passportLastName
                                  .required &&
                                $v.guests.$each[i].passportLastName.$error
                              ">
                                Obrigatório.
                              </span>
                              <span class="text-danger" v-if="
                                $v.guests.$each[i].passportLastName
                                  .required &&
                                $v.guests.$each[i].passportLastName.$invalid
                              ">
                                Máx 23 caracteres
                              </span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].passportNumber.$error,
                            }">
                              <label for="">Número do passaporte
                                <span v-if="!guest.hasPassport">*</span></label>
                              <input type="text" @input="
                                $v.guests.$each[i].passportNumber.$touch()
                                " placeholder="Número do passaporte" v-model="guest.passportNumber" autofocus />
                              <span class="text-danger"
                                v-if="$v.guests.$each[i].passportNumber.$error">Obrigatório.</span>
                              <span class="text-danger" v-if="
                                $v.guests.$each[i].passportNumber.required &&
                                $v.guests.$each[i].passportNumber.$invalid
                              ">
                                <span style="font-size: 75%">Máx 23 caracteres</span>
                              </span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].nacionality.$error,
                            }">
                              <label for="">Nacionalidade
                                <span v-if="!guest.hasPassport">*</span></label>
                              <input type="text" @input="$v.guests.$each[i].nacionality.$touch()"
                                placeholder="Nacionalidade" v-model="guest.nacionality" autofocus />
                              <span class="text-danger" v-if="$v.guests.$each[i].nacionality.$error">Obrigatório.</span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].passportAuthority.$error,
                            }">
                              <label for="">País emissor
                                <span v-if="!guest.hasPassport">*</span></label>
                              <input type="text" @input="
                                $v.guests.$each[i].passportAuthority.$touch()
                                " placeholder="País emissor " v-model="guest.passportAuthority" autofocus />
                              <span class="text-danger" v-if="
                                $v.guests.$each[i].passportAuthority.$error
                              ">Obrigatório.</span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].passportValidity.$error,
                            }">
                              <label for="">Data de validade do passaporte
                                <span v-if="!guest.hasPassport">*</span></label>
                              <input type="text" @input="
                                $v.guests.$each[i].passportValidity.$touch()
                                " placeholder="Validade do passaporte " v-model="guest.passportValidity"
                                v-mask="'##/##/####'" autofocus />
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].passportValidity
                                  .required &&
                                $v.guests.$each[i].passportValidity.$error
                              " style="font-size: 10px">
                                Obrigatório.
                              </span>
                              <span class="text-danger" v-if="
                                $v.guests.$each[i].passportValidity
                                  .required &&
                                $v.guests.$each[i].passportValidity.$invalid
                              ">Inválida.
                              </span>
                            </div>
                          </div>
                          <!-- <div class="col-lg-4 col-sm-6">
                            <div
                              class="form-group"
                              :class="{
                                'has-error': $v.guests.$each[i].name.$error,
                              }"
                            >
                              <label for="">Nome de reconhecimento *</label>
                              <input
                                type="text"
                                @input="$v.guests.$each[i].name.$touch()"
                                placeholder="Nome de reconhecimento *"
                                v-model="guest.name"
                                autofocus
                              />
                              <span
                                class="text-danger"
                                v-if="
                                  !$v.guests.$each[i].name.required &&
                                  $v.guests.$each[i].name.$error
                                "
                              >
                                Obrigatório.
                              </span>
                              <span
                                class="text-danger"
                                v-if="
                                  $v.guests.$each[i].name.required &&
                                  $v.guests.$each[i].name.$invalid
                                "
                              >
                                Máx 23 caracteres
                              </span>
                            </div>
                          </div> -->
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].dateOfBirth.$error,
                            }">
                              <label for="">Data de Nascimento *</label>
                              <input type="text" @input="$v.guests.$each[i].dateOfBirth.$touch()"
                                placeholder="Data de Nascimento *" v-model="guest.dateOfBirth" v-mask="'##/##/####'"
                                autofocus />
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].dateOfBirth.required &&
                                $v.guests.$each[i].dateOfBirth.$error
                              ">
                                Obrigatório.
                              </span>
                              <span class="text-danger" v-if="
                                $v.guests.$each[i].dateOfBirth.required &&
                                $v.guests.$each[i].dateOfBirth.$invalid
                              ">Inválida.
                              </span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error': $v.guests.$each[i].cpf.$error,
                            }">
                              <label for="">CPF *</label>
                              <input type="text" @input="$v.guests.$each[i].cpf.$touch()" placeholder="CPF *"
                                v-model="guest.cpf" v-mask="'###.###.###-##'" autofocus />
                              <span class="text-danger" v-if="$v.guests.$each[i].cpf.$error">Inválido.</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error': $v.guests.$each[i].rg.$error,
                            }">
                              <label for="">RG <span v-if="!guest.hasRg">*</span></label>
                              <input type="text" @input="$v.guests.$each[i].rg.$touch()" placeholder="RG *"
                                v-model="guest.rg" autofocus />
                              <span class="text-danger" v-if="$v.guests.$each[i].rg.$error">Inválido.</span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error': $v.guests.$each[i].rg.$error,
                            }">
                              <label for="">Validade do RG <span v-if="!guest.hasRg">*</span></label>
                              <input type="text" @input="$v.guests.$each[i].validadeRg.$touch()" placeholder="Validade do RG *"
                                v-model="guest.validadeRg" v-mask="'##/##/####'" autofocus />
                              <span class="text-danger" v-if="$v.guests.$each[i].validadeRg.$error">Inválido.</span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="checkbox">
                              <input type="checkbox" :id="'hasRg' + i" v-model="guest.hasRg"
                                @change="$v.guests.$reset()" />
                              <label :for="'hasRg' + i">
                                <small>Não possuo</small>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].cellPhone.$error,
                            }">
                              <label for="">Celular *</label>
                              <input type="cellPhone" @input="$v.guests.$each[i].cellPhone.$touch()"
                                placeholder="Celular *" v-model="guest.cellPhone" v-mask="'(##) #####-####'"
                                autofocus />
                              <span class="text-danger" v-if="$v.guests.$each[i].cellPhone.$error">
                                Inválido.
                              </span>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6">
                            <div class="form-group radio-content" :class="{
                              'has-error': $v.guests.$each[i].gender.$error,
                            }">
                              <label for="" class="control-label visible-label">Sexo *</label>
                              <br />
                              <input type="radio" name="gender" :id="'male' + (i + 1)" value="1"
                                v-model="guest.gender" />
                              <label :for="'male' + (i + 1)">Masculino</label>
                              <input type="radio" name="gender" :id="'female' + (i + 1)" value="2"
                                v-model="guest.gender" />
                              <label :for="'female' + (i + 1)">Feminino</label>
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].gender.required &&
                                $v.guests.$each[i].gender.$error
                              ">Obrigatório.</span>
                            </div>
                          </div>

                          <div class="col-lg-6 col-sm-6">
                            <div class="form-group select select-fancy select-fancy-noimage" :class="{
                              'has-error': $v.guests.$each[i].kinship.$error,
                            }">
                              <label for="">Grau de parentesco *</label>
                              <select v-model="guest.kinship" @change="
                                onChangeKinship($event.target.value, i)
                                ">
                                <option value="null" disabled selected>
                                  Selecione o grau:
                                </option>
                                <option v-for="(kinship, index) in kinshipList" :key="kinship" :value="index">
                                  {{ kinship }}
                                </option>
                              </select>
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].kinship.required &&
                                $v.guests.$each[i].kinship.$error
                              ">Obrigatório.</span>
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6">
                            <div class="form-group select select-fancy select-fancy-noimage" :class="{
                              'has-error': $v.guests.$each[i].foodId.$error,
                            }">
                              <label for="">Restrição/Necessidade alimentar *</label>
                              <select v-model="guest.foodId">
                                <option value="null" disabled selected>
                                  Selecione o tipo:
                                </option>
                                <option v-for="food in foodList" :key="food.id" :value="food.id">
                                  {{ food.name }}
                                </option>
                              </select>
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].foodId.required &&
                                $v.guests.$each[i].foodId.$error
                              " style="font-size: 6.5px">Obrigatório.</span>
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6" v-if="guest.foodId == 9">
                            <div class="form-group">
                              <label for="">Descreva sua restrição alimentar</label>
                              <input type="text" name="otherFood" v-model="guest.otherFood" />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6">
                            <div class="form-group select select-fancy select-fancy-noimage" :class="{
                              'has-error': $v.guests.$each[i].pwdId.$error,
                            }">
                              <label for="">Necessidades especiais *</label>
                              <select v-model="guest.pwdId">
                                <option value="null" disabled selected>
                                  Selecione o tipo:
                                </option>
                                <option v-for="pwd in pwdList" :key="pwd.id" :value="pwd.id">
                                  {{ pwd.name }}
                                </option>
                              </select>
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].pwdId.required &&
                                $v.guests.$each[i].pwdId.$error
                              " style="font-size: 6.5px">Obrigatório.</span>
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6" v-if="guest.pwdId == 5">
                            <div class="form-group">
                              <label for="">Descreva sua outra necessidade especial</label>
                              <input type="text" name="otherPwd" v-model="guest.otherPwd" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error': $v.guests.$each[i].name.$error,
                            }">
                              <label for="">Nome de crachá *</label>
                              <input type="text" @input="$v.guests.$each[i].name.$touch()"
                                placeholder="Nome de crachá *" v-model="guest.name" autofocus />
                              <span class="text-danger" v-if="
                                !$v.guests.$each[i].name.required &&
                                $v.guests.$each[i].name.$error
                              ">
                                Obrigatório.
                              </span>
                              <span class="text-danger" v-if="
                                $v.guests.$each[i].name.required &&
                                $v.guests.$each[i].name.$invalid
                              ">
                                Máx 23 caracteres
                              </span>
                            </div>
                          </div>
                          <div class="col-lg-6 col-sm-6">
                            <div class="form-group" :class="{
                              'has-error': $v.guests.$each[i].ptcCount.$error,
                            }">
                              <label for="">Qtd de PTC's (Contando com 2025) *</label>
                              <input type="text" @input="$v.guests.$each[i].ptcCount.$touch()"
                                placeholder="Qtd de PTC's *" v-model="guest.ptcCount" autofocus
                                title="Qtd de PTC's" v-mask="'####'" />
                              <span class="text-danger" v-if="$v.guests.$each[i].ptcCount.$error">Obrigatório.</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6 col-sm-12">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].startCity.$error,
                            }">
                              <label for="">Cidade de partida / Aeroporto de partida
                                *</label>
                              <input type="text" @input="$v.guests.$each[i].startCity.$touch()"
                                placeholder="Cidade de partida / Aeroporto de partida *" v-model="guest.startCity"
                                autofocus />
                              <span class="text-danger" v-if="$v.guests.$each[i].startCity.$error">Obrigatório.</span>
                            </div>
                          </div>
                          <div class="col-lg-6 col-sm-12">
                            <div class="form-group" :class="{
                              'has-error':
                                $v.guests.$each[i].returnCity.$error,
                            }">
                              <label for="">Cidade de retorno / Aeroporto de retorno
                                *</label>
                              <input type="text" @input="$v.guests.$each[i].returnCity.$touch()"
                                placeholder="Cidade de retorno / Aeroporto de retorno *" v-model="guest.returnCity"
                                autofocus />
                              <span class="text-danger" v-if="$v.guests.$each[i].returnCity.$error">Obrigatório.</span>
                            </div>
                          </div>
                          <div class="col-lg-6 col-sm-12">
                            <div class="form-group">
                              <label for="" class="control-label float-label" style="
                                  width: 100%;
                                  padding-bottom: 4px;
                                  background-color: #fff;
                                ">Observação</label>
                              <textarea maxlength="155" v-model="guest.observation" class="form-control"
                                @input="$v.guests.$each[i].observation.$touch()" rows="2" cols="2"
                                placeholder="Alguma observação?"></textarea>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="row">
                          <div class="col-lg-3 col-sm-6">
                            <div class="checkbox">
                              <input type="checkbox" :id="'hasVisa' + i" 
                                v-model="guest.hasVisa" @change="$v.guests.$reset()">
                              <label :for="'hasVisa' + i">
                                <small>Não possui visto americano?</small>
                              </label>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6" v-if="!guest.hasVisa">
                            <div class="form-group" 
                              :class="{ 'has-error': $v.guests.$each[i].visaValidity.$error }">
                              <label for="">Data de validade do visto *</label>
                              <input type="text" @input="$v.guests.$each[i].visaValidity.$touch()" placeholder="Validade do visto *" v-model="guest.visaValidity" v-mask="'##/##/####'" autofocus>
                              <span class="text-danger" 
                                v-if="!$v.guests.$each[i].visaValidity.required && 
                                  $v.guests.$each[i].visaValidity.$error">
                                Obrigatório.
                              </span>
                              <span class="text-danger" 
                                v-if="$v.guests.$each[i].visaValidity.required &&
                                  $v.guests.$each[i].visaValidity.$invalid">
                                Inválida.
                              </span>
                            </div>
                          </div>
                        </div> -->
                        <div class="row">
                          <div class="col-lg-3 col-sm-6">
                            <div class="checkbox">
                              <input type="checkbox" :id="'hasPassport' + i" v-model="guest.hasPassport"
                                @change="$v.guests.$reset()" />
                              <label :for="'hasPassport' + i">
                                <small>Não possui passaporte?</small>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- <div class="col-lg-12">
              <div class="checkbox" style="margin: 15px" v-if="!showThirdInfo">
                <p>
                  Importante:<br />
                  Caso seu acompanhante extra seja um menor de 3 anos e 11 meses
                  de idade, apesar de não ter custos para o evento, o mesmo terá
                  um valor a pagar pelo voo. Essa despesa será informada pela
                  cia no momento da emissão *** Valores referentes a taxas para
                  crianças de até 1 ano e 11 meses ***
                </p>
              </div>
            </div> -->
            <div class="action-buttons add-guest" v-if="!showThirdInfo">
              <custom-button @clicked="
                showThirdInfo = true;
              scrollOnTop();
              " myText="Voltar" icon="chevron-left" pos="left"></custom-button>
              <custom-button style="background: green" @clicked="addGuest" myText="Incluir Acompanhante"
                class="add-guest-button" pos="left" icon="plus"></custom-button>
              <custom-button :disabled="$v.guests.$error" @clicked="
                changeTab(
                  'Confirmação',
                  $v.guests.$each.$invalid,
                  $v.guests.$touch(),
                  'post'
                );
              scrollOnTop();
              " myText="Escolher Voos" icon="chevron-right" pos="right"></custom-button>
            </div>
          </tab>
          <tab id="tab3" name="Confirmação" :tabName="tabName" :isValid="true" icon="icon icon-tab3">
            <div class="row finish">
              <div class="panel-group">
                <div class="panel">
                  <div class="col-md-12">
                    <div class="col-md-12 content-box">
                      <p class="register-success">
                        Inscrição Corretores Franqueados e acompanhantes
                      </p>
                      <div>
                        <p>
                          Por favor confira se todos os dados preenchidos estão
                          corretos e caso tenha alguma informação divergente
                          clique em 'VOLTAR' e realize a correção. <br />Se
                          todas as informações estiverem corretas clique em
                          'PRÓXIMO'.
                        </p>
                      </div>
                      <br />
                      <p class="form-conference-title">
                        <b>Dados do participante</b>
                      </p>
                      <div class="row form-conference">
                        <div class="col-lg-6 col-sm-12">
                          <label><b>Nome conforme passaporte: </b></label>
                          <p>{{ participant.passportFirstName }}</p>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                          <label><b>Sobrenome conforme passaporte: </b></label>
                          <p>{{ participant.passportLastName }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Número do passaporte: </b></label>
                          <p>{{ participant.passportNumber }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Nacionalidade: </b></label>
                          <p>{{ participant.nacionality }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>País Emissor: </b></label>
                          <p>{{ participant.passportAuthority }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Data de validade do passaporte: </b></label>
                          <p>{{ participant.passportValidity }}</p>
                        </div>
                        <!-- <div class="col-lg-4 col-sm-12">
                          <label><b>Nome completo: </b></label>
                          <p>{{ participant.badgeName }}</p>
                        </div> -->
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Data de Nascimento: </b></label>
                          <p>{{ participant.dateOfBirth }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>CPF: </b></label>
                          <p>{{ participant.cpf }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>RG: </b></label>
                          <p>{{ participant.rg }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Validade RG: </b></label>
                          <p>{{ participant.validadeRg }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Email: </b></label>
                          <p>{{ participant.email }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Telefone celular: </b></label>
                          <p>{{ participant.cellPhone }}</p>
                        </div>

                        <div class="col-lg-4 col-sm-12">
                          <label><b>Sexo: </b></label>
                          <p>
                            {{
                              participant.gender == 1 ? "Masculino" : "Feminino"
                            }}
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>CPD: </b></label>
                          <p>{{ participant.registration }}</p>
                        </div>

                        <div class="col-lg-4 col-sm-12">
                          <label><b>Restrição/Necessidade alimentar: </b></label>
                          <p>
                            {{ getFoodById(participant.foodId) }}
                            <span v-if="participant.otherFood">
                              / {{ participant.otherFood }}</span>
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Necessidades especiais: </b></label>
                          <p>
                            {{ getPwdById(participant.pwdId) }}
                            <span v-if="participant.otherPwd">
                              / {{ participant.otherPwd }}</span>
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Cidade de partida / Aeroporto de partida:
                            </b></label>
                          <p>{{ participant.startCity }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Cidade de retorno / Aeroporto de retorno:
                            </b></label>
                          <p>{{ participant.returnCity }}</p>
                        </div>
                        <!-- <div class="col-lg-4 col-sm-12">
                          <label><b>Ponto de Apoio: </b></label>
                          <p>{{ participant.supportPoint }}</p>
                        </div> -->
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Possui passaporte?: </b></label>
                          <p>{{ !participant.hasPassport ? "Sim" : "Não" }}</p>
                        </div>
                      </div>
                      <p v-if="guests.length !== 0" class="form-conference-title">
                        <b>Dados do(s) acompanhante(s)</b>
                      </p>
                      <div v-for="(guest, i) in guests" :key="i" class="row form-conference">
                        <div class="guest-title-counter">
                          <label style="margin-bottom: 15px"><b>ACOMPANHANTE {{ i + 1 }}</b></label>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                          <label><b>Nome conforme passaporte: </b></label>
                          <p>{{ guest.passportFirstName }}</p>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                          <label><b>Sobrenome conforme passaporte: </b></label>
                          <p>{{ guest.passportLastName }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Número do passaporte: </b></label>
                          <p>{{ guest.passportNumber }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Nacionalidade: </b></label>
                          <p>{{ guest.nacionality }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>País Emissor: </b></label>
                          <p>{{ guest.passportAuthority }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Data de validade do passaporte: </b></label>
                          <p>{{ guest.passportValidity }}</p>
                        </div>
                        <!-- <div class="col-lg-4 col-sm-12">
                          <label><b>Nome de reconhecimento: </b></label>
                          <p>{{ guest.name }}</p>
                        </div> -->
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Data de Nascimento: </b></label>
                          <p>{{ guest.dateOfBirth }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>CPF: </b></label>
                          <p>{{ guest.cpf }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>RG: </b></label>
                          <p>{{ guest.rg }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Validade do RG: </b></label>
                          <p>{{ guest.validadeRg }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Telefone celular: </b></label>
                          <p>{{ guest.cellPhone }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Sexo: </b></label>
                          <p>
                            {{ guest.gender == 1 ? "Masculino" : "Feminino" }}
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Grau de parentesco: </b></label>
                          <p>
                            {{ kinshipList[guest.kinship] }}
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Restrição/Necessidade alimentar: </b></label>
                          <p>
                            {{ getFoodById(guest.foodId) }}
                            <span v-if="guest.otherFood">
                              / {{ guest.otherFood }}</span>
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Necessidades especiais: </b></label>
                          <p>
                            {{ getPwdById(guest.pwdId) }}
                            <span v-if="guest.otherPwd">
                              / {{ guest.otherPwd }}</span>
                          </p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Cidade de partida / Aeroporto de partida:
                            </b></label>
                          <p>{{ guest.startCity }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Cidade de retorno / Aeroporto de retorno:
                            </b></label>
                          <p>{{ guest.returnCity }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Nome de crachá </b></label>
                          <p>{{ guest.name }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Qtd de PTC's (Contando com 2025): </b></label>
                          <p>{{ guest.ptcCount }}</p>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                          <label><b>Possui passaporte?: </b></label>
                          <p>{{ !guest.hasPassport ? "Sim" : "Não" }}</p>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                          <label><b>Observação: </b></label>
                          <p>{{ guest.observation }}</p>
                        </div>
                      </div>
                      <div class="row">
                        <!-- <p>
                          Ao clicar no botão “Finalizar” sua inscrição e escolha
                          dos voos de seus acompanhantes, qualificados e extras,
                          estão concluídas e não serão possível fazer
                          alterações.
                        </p> -->
                        <!-- <p>
                          Fique atento(a), após conclusão você receberá um
                          e-mail confirmando a inscrição e escolha do voo.
                          Somente após o recebimento dessa mensagem está
                          garantida a indicação dos acompanhantes e seleção dos
                          voos.
                        </p> -->
                        <!-- <p>
                          Caso não receba esse e-mail por favor entre em contato
                          com a Origami. <br />
                          PREFERENCIALMENTE VIA WHATSAPP, com a Central de
                          Atendimento exclusiva da PTC no número: (21)
                          99981-5040 | (21) 3798 9010. Horário de atendimento:
                          segunda a sexta de 9h às 18h.
                        </p> -->
                        <!-- <hr /> -->
                        <custom-button @clicked="
                          changeTab('Acompanhantes');
                        scrollOnTop();
                        " myText="Voltar" icon="chevron-left" pos="left"></custom-button>
                        <!-- <custom-button
                          @clicked="sendGuests()"
                          myText="Finalizar"
                          icon="sign-out"
                          pos="left"
                        ></custom-button> -->
                        <custom-button @clicked="sendGuests()" myText="Próximo" icon="chevron-right"
                          pos="left"></custom-button>
                        <p class="copyright">
                          <a class="fancy" href="http://www.origamieventos.com.br/" target="_blank">© 2025 Origami
                            Eventos e Turismo</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <footer-component></footer-component>
    </main>
  </div>
</template>
<script>
import * as Helper from "./../methods/helpers";
import Infos from "./Infos.vue";
import CustomButtom from "./shared/CustomButton.vue";
import Footer from "./shared/Footer.vue";
import Modal from "./shared/Modal.vue";
import NavBar from "./shared/NavBar.vue";
import Tab from "./shared/Tab.vue";
import Tabs from "./shared/Tabs.vue";

import {
  email,
  maxLength,
  minLength,
  required,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  data: function () {
    return {
      showFirstInfo: true,
      showSecondInfo: false,
      showThirdInfo: false,
      confirmInfo: false,
      participant: {
        badgeName: "",
        email: "",
        cpf: "",
        rg: "",
        validadeRg: "",
        hasRg: false,
        registration: "",
        cellPhone: "",
        gender: "",
        dateOfBirth: "",
        hasPassport: false,
        confirmInfo: false,
        completed: false,
        startCity: "",
        returnCity: "",
        // supportPoint: "",
        // hasVisa: false,
        // visaValidity: '',
        foodId: "",
        otherFood: "",
        pwdId: "",
        passportFirstName: "",
        passportLastName: "",
        passportNumber: "",
        nacionality: "",
        passportAuthority: "",
        passportValidity: "",
      },
      guests: [
        // {
        //   id: 1,
        //   name: "",
        //   cellPhone: "",
        //   gender: "",
        //   dateOfBirth: "",
        //   cpf: "",
        //   kinship: "",
        //   // hasVisa: false,
        //   // visaValidity: '',
        //   hasPassport: false,
        //   foodId: "",
        //   pwdId: "",
        //   otherFood: "",
        //   otherPwd: "",
        //   participantId: "",
        //   observation: "",
        //   startCity: "",
        //   returnCity: "",
        //   ptcCount: "",
        //   new: true,
        //   passportFirstName: "",
        //   passportLastName: "",
        //   passportNumber: "",
        //   nacionality: "",
        //   passportAuthority: "",
        //   passportValidity: "",
        // },
      ],
      foodList: [],
      pwdList: [],
      kinshipList: [],
      citiesList: [],
      tabName: "",
      isFormValid: true,
      guestAdded: false,
      canRegister: true,
      finalRegister: "",
      startFlight: "",
      canSelectFlight: false,
      hasErrors: false,
      displayModal: false,
      displayConfirmInfo: false,
      displayPassportValidityInfo: false,
      displayFlightModal: false,
      displayInvalidModal: false,
      displaySuccessModal: false,
      displayPartnerInfo: false,
      displayCityInfo: false,
      displayPassportName: false,
      displayPassportNumber: false,
      displayPassportCountry: false,
      displaySpouseMessage: false,
      loading: false,
      startEvent: null,
      finalEvent: null,
      message: {
        show: false,
        title: "",
        body: "",
        type: false,
        logout: false,
      },
      firstTravel: "",
    };
  },
  components: {
    navbar: NavBar,
    tabs: Tabs,
    tab: Tab,
    "custom-button": CustomButtom,
    modal: Modal,
    "footer-component": Footer,
    infos: Infos,
  },
  watch: {
    // guests: function () {
    //   let num = this.guests.length;
    //   if (num > 1) {
    //     setTimeout(() => {
    //       let el = document.querySelectorAll("[data-name='guest-form']");
    //       if (el.length > 0) {
    //         el[num - 1].classList.toggle("animation-jack");
    //       }
    //     }, 0);
    //   }
    // },
    "participant.foodId": function (id) {
      if (this.foodList.length > 0) {
        if (this.foodList[this.foodList.length - 1].id === id)
          this.displayModal = true;
      }
    },
    "participant.pwdId": function (id) {
      if (this.pwdList.length > 0) {
        if (this.pwdList[this.pwdList.length - 1].id === id)
          this.displayModal = true;
      }
    },
  },
  validations: function () {
    return {
      participant: {
        email: { required, email, maxLength: maxLength(150) },
        cpf: { required, minLength: minLength(14), maxLength: maxLength(14) },
        rg:  !this.participant.hasRg ? { required, minLength: minLength(6), maxLength: maxLength(18) } : {},
        validadeRg: !this.participant.hasRg ? { 
          required,
          maxLength: maxLength(10),
          minLength: minLength(10),
          isValidDate: function (value) {
            return Helper.isValidDate(value, false);
          },
        }: {},
        registration: { required, maxLength: maxLength(150) },
        cellPhone: { required, minLength: minLength(14) },
        dateOfBirth: {
          required,
          minLength: minLength(10),
          isValidDate: function (value) {
            return Helper.isValidDate(value, true);
          },
        },
        gender: { required },
        startCity: { required },
        returnCity: { required },
        // supportPoint: { required },
        // visaValidity: !this.participant.hasVisa ? {
        //   required,
        //   minLength: minLength(10),
        //   isValidDate: function (value) {
        //     return Helper.isValidDate(value);
        //   }
        // } : {},
        passportValidity: !this.participant.hasPassport
          ? {
            required,
            minLength: minLength(10),
            isValidDate: function (value) {
              let isValid = Helper.isValidDate(value);
              if (isValid) {
                //Check if is valid after 6 mouths from first travel
                let expirationDate = new Date();
                expirationDate = expirationDate.setMonth(
                  expirationDate.getMonth() + 6
                );
                let parts = value.split("/");
                let day = parseInt(parts[0], 10);
                let month = parseInt(parts[1], 10);
                let year = parseInt(parts[2], 10);
                let date = new Date(`${month}/${day}/${year}`);
                if (date < expirationDate) {
                  this.displayPassportValidityInfo = true;
                }
              }
              return isValid;
            },
          }
          : {},
        passportFirstName: !this.participant.hasPassport ? { required } : {},
        passportLastName: !this.participant.hasPassport ? { required } : {},
        passportNumber: !this.participant.hasPassport ? { required } : {},
        nacionality: !this.participant.hasPassport ? { required } : {},
        passportAuthority: !this.participant.hasPassport ? { required } : {},
        foodId: { required },
        pwdId: { required },
      },
      guests: {
        required,
        $each: {
          name: { required, maxLength: maxLength(150) },
          cellPhone: { required, minLength: minLength(14) },
          gender: { required },
          dateOfBirth: {
            required,
            minLength: minLength(10),
            isValidDate: function (value) {
              return Helper.isValidDate(value, true);
            },
          },
          cpf: { required, minLength: minLength(14), maxLength: maxLength(14) },
          rg: { required: requiredIf(function (guest) {
              return guest.hasRg === false;
            }), minLength: minLength(6), maxLength: maxLength(18) },
          validadeRg: { 
            required: requiredIf(function (guest) {
              return guest.hasRg === false;
            }), 
            minLength: minLength(10),
            maxLength: maxLength(10),
            isValidDate: function (value) {
              return Helper.isValidDate(value, false);
            }, 
          },
          kinship: { required },
          startCity: { required },
          returnCity: { required },
          ptcCount: { required },
          observation: { maxLength: maxLength(200) },
          specialNeeds: { maxLength: maxLength(150) },
          // visaValidity: {
          //   required: requiredIf(function (guest) { return guest.hasVisa === false }),
          //   isValidDate: function (value, guest) {
          //     return guest.hasVisa === false ? Helper.isValidDate(value) : true;
          //   }
          // },
          passportValidity: {
            required: requiredIf(function (guest) {
              return guest.hasPassport === false;
            }),
            isValidDate: function (value, guest) {
              if (guest.hasPassport === false) {
                let isValid = Helper.isValidDate(value);
                if (isValid) {
                  //Check if is valid after 6 mouths from first travel
                  let expirationDate = new Date();
                  expirationDate = expirationDate.setMonth(
                    expirationDate.getMonth() + 6
                  );
                  let parts = value.split("/");
                  let day = parseInt(parts[0], 10);
                  let month = parseInt(parts[1], 10);
                  let year = parseInt(parts[2], 10);
                  let date = new Date(`${month}/${day}/${year}`);
                  if (date < expirationDate) {
                    this.displayPassportValidityInfo = true;
                  }
                }
                return isValid;
              }
              return true;
            },
          },
          passportFirstName: {
            required: requiredIf(function (guest) {
              return guest.hasPassport === false;
            }),
          },
          passportLastName: {
            required: requiredIf(function (guest) {
              return guest.hasPassport === false;
            }),
          },
          passportNumber: {
            required: requiredIf(function (guest) {
              return guest.hasPassport === false;
            }),
          },
          nacionality: {
            required: requiredIf(function (guest) {
              return guest.hasPassport === false;
            }),
          },
          passportAuthority: {
            required: requiredIf(function (guest) {
              return guest.hasPassport === false;
            }),
          },
          foodId: { required },
          pwdId: { required },
        },
      },
    };
  },
  mounted: function () {
    this.loading = true;

    this.$http.get(`sync`).then((response) => {
      this.loading = false;
      this.citiesList = response.data.cities;
      this.foodList = response.data.foods;
      this.pwdList = response.data.pwd;
      this.kinshipList = response.data.kinship;
      this.$store.commit("setUser", response.data.user);

      if (window.localStorage) {
        window.localStorage.setItem("user", JSON.stringify(response.data.user));
      }

      if (this.$store.state.user.participant.length === undefined) {
        this.participant = this.$store.state.user.participant;
        this.participant.dateOfBirth = Helper.formatDate(
          this.participant.dateOfBirth
        );
        if (this.participant.passportValidity !== null) {
          this.participant.passportValidity = Helper.formatDate(
            this.participant.passportValidity
          );
        }
        // if (this.participant.visaValidity !== null) {
        //   this.participant.visaValidity = Helper.formatDate(this.participant.visaValidity);
        // }
      } else {
        this.participant.badgeName = this.$store.state.user.badgeName;
        this.participant.registration = this.$store.state.user.registration;
        this.participant.id = false;
        this.participant.hasPassport = false;
        this.participant.hasVisa = false;
      }
      this.participant.email = this.$store.state.user.email;

      let user = response.data.user;
      this.canRegister = response.data.configs.canRegister;
      this.finalRegister = response.data.configs.finalRegister;
      this.startFlight = response.data.configs.startFlight;
      this.canSelectFlight = response.data.configs.canSelectFlight;

      this.startEvent = response.data.configs.startEvent;
      this.finalEvent = response.data.configs.finalEvent;
      this.$store.commit("setStartEvent", this.startEvent);
      this.$store.commit("setFinalEvent", this.finalEvent);

      if (this.canSelectFlight === true && user.completed !== null) {
        this.$router.push({ name: "flight" });
      }

      if (!this.canRegister) {
        this.displayFlightModal = true;
        return;
      }

      if (
        this.participant.guests !== undefined &&
        this.participant.guests.length > 0
      ) {
        this.guests = this.participant.guests.map((guest) => {
          guest.dateOfBirth = Helper.formatDate(guest.dateOfBirth);
          if (guest.passportValidity !== null) {
            guest.passportValidity = Helper.formatDate(guest.passportValidity);
          }
          // if (guest.visaValidity !== null) {
          //   guest.visaValidity = Helper.formatDate(guest.visaValidity);
          // }
          return guest;
        });
        this.confirmInfo = true;
      }

      // check if is going back from flights section
      const step = this.$route.query.step;
      if (step === 'last') {
        this.changeTab('Confirmação');
        this.scrollOnTop();
      }
    });
  },
  methods: {
    scrollOnTop: function () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    onChangeKinship: function (value, index) {
      // if (value == 9 || value == 10 || value == 11) {
      //   this.displayPartnerInfo = true;
      // }
      if (value == 1) {
        const hasSpouse = this.guests.find((guest, i) => {
          return guest.kinship == 1 && index !== i;
        });
        if (hasSpouse) {
          this.guests[index].kinship = "";
          this.displaySpouseMessage = true;
        }
      }
      // this.$v.guests.$each[i].kinship.$touch()
    },
    sendUser: function (tab) {
      this.loading = true;

      let participant = this.participant;

      // if (participant.hasVisa === true) {
      //   participant.visaValidity = null;
      // }
      const formData = new FormData();
      this.buildFormData(formData, participant);

      this.$http
        .post(`participants`, formData)
        .then((response) => {
          this.participant.id = response.data.participant.id;
          this.tabName = tab;
          this.loading = false;
          this.clearAnimationClasses();
        })
        .catch((response) => {
          this.loading = false;
          this.hasErrors = true;
        });
    },
    openModal: function (title, body, type = false, logout = false) {
      const show = true;
      this.message = { show, title, body, type, logout };
    },
    sendGuests: function () {
      this.loading = true;
      let data = { guests: [] };
      if (this.guests.length > 0) {
        this.guests[0].participantId = this.participant.id;
        const formData = new FormData();
        this.buildFormData(formData, { guests: this.guests });
        data = formData;
      }

      this.$http
        .post(`guests`, data)
        .then((response) => {
          this.guests = response.data.guests;
          this.guests.map((guest) => {
            guest.dateOfBirth = Helper.formatDate(guest.dateOfBirth);
            // if (guest.visaValidity !== null) {
            //   guest.visaValidity = Helper.formatDate(guest.visaValidity);
            // }
            return guest;
          });
          this.$store.state.user.completed = 1;
          this.loading = false;
          this.clearAnimationClasses();
          // Modal para finalizar a primeira etapa
          //
          // this.openModal(
          //   "Sucesso",
          //   "Cadastro finalizado com sucesso!",
          //   "info",
          //   true
          // );

          // Ação para direcionar para escolha do voo sem fazer login novamente
          this.scrollOnTop();
          this.$router.push({ name: "flight" });

          window.localStorage.setItem(
            "user",
            JSON.stringify(this.$store.state.user)
          );
        })
        .catch((response) => {
          this.loading = false;
          this.hasErrors = true;
        });
    },
    buildFormData: function (formData, data, parentKey) {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          );
        });
      } else {
        const value = data == null ? "" : data;
        formData.append(parentKey, value);
      }
    },
    logout: function () {
      this.$store.commit("setUser", null);
      this.$store.commit("setToken", null);
      window.localStorage.setItem("client_origami_user", null);
      window.localStorage.setItem("client_origami_token", null);
      this.$router.push({ name: "login" });
    },
    changeTab: function (tab, isInvalid, touched, showInfo = false, status) {
      if (showInfo) {
        this[showInfo] = status;
      }
      if (!isInvalid) {
        if (
          (this.tabName === "" || this.tabName === "Cadastro") &&
          tab === "Acompanhantes"
        ) {
          this.sendUser(tab);
        } else if (tab === "Confirmação") {
          // if (this.confirmInfo === false && this.guests.length !== 0) {
          //   this.displayConfirmInfo = true;
          // } else {
          this.tabName = tab;
          // }
        } else {
          this.tabName = tab;
          this.clearAnimationClasses();
        }
      }
    },
    clearAnimationClasses: function () {
      setTimeout(() => {
        let classes = Array.from(
          document.querySelectorAll("[data-name='guest-form']")
        );
        classes.forEach((node) => {
          node.classList.remove("animation-jack");
        });
      }, 0);
    },
    addGuest: function () {
      if (this.guests.length < 20) {
        let id = 1;
        if (this.guests.length !== 0) {
          id = this.guests[this.guests.length - 1].id + 1;
        }
        this.guests.push({
          id: id,
          name: "",
          email: "",
          cpf: "",
          rg: "",
          validadeRg: "",
          hasRg: false,
          gender: "",
          dateOfBirth: "",
          hasVisa: false,
          visaValidity: "",
          hasPassport: false,
          kinship: "",
          foodId: "",
          pwdId: "",
          otherFood: "",
          otherPwd: "",
          observation: "",
          participantId: this.participant.id,
          ptcCount: "",
          new: true,
        });
        setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 10);
      }
      this.$v.guests.$reset();
    },
    removeGuest: function (idx, id) {
      if (this.guests.length > 0) {
        let number = idx + 1;
        let answer = confirm(
          `Tem certeza que deseja excluir o Acompanhante de nº ${number}? Essa ação não poderá ser desfeita`
        );
        if (answer == true) {
          if (this.guests[idx].createdAt) {
            this.loading = true;
            this.$http.delete(`guests/${id}`).finally(() => {
              this.loading = false;
            });
          }
          this.guests.splice(idx, 1);
        }
        this.$v.guests.$reset();
      }
    },
    closeModal: function () {
      this.hasErrors = false;
      this.displayModal = false;
      this.displayConfirmInfo = false;
      this.displayPassportValidityInfo = false;
      this.displayFlightModal = false;
      this.displayInvalidModal = false;
      this.displayPartnerInfo = false;
      this.displayCityInfo = false;
      this.displayPassportName = false;
      this.displayPassportNumber = false;
      this.displayPassportCountry = false;
      this.displaySpouseMessage = false;
      this.loading = false;
    },
    isMobile: function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    getFoodById: function (id) {
      return id !== "" && this.foodList
        ? this.foodList.find((item) => item.id === id).name
        : "";
    },
    getPwdById: function (id) {
      return id !== "" && this.pwdList
        ? this.pwdList.find((item) => item.id === id).name
        : "";
    },
  },
};
</script>

<style>
input[type="text"]:disabled {
  background: #fff;
}

.fa-question-circle {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Register.vue